<template>
  <InsurancePlanFilter
    inline
    close-on-select
    start-on-root
    :model-value="insurancePlan"
    :non-clearable="nonClearable"
    @update:model-value="insuranceChanged"
  >
    <template #activator>
      <sp-button class="activator" variant="appearance-link" :data-testid="TestId.insurance.planActivator">{{
        title
      }}</sp-button>
    </template>
  </InsurancePlanFilter>
</template>

<script setup>
import { TestId } from "#/test-ids";
import InsurancePlanFilter from "#ce/shared/filters/insurance-plan/components/InsurancePlanFilter.ce.vue";
import { booleanAttribute } from "#ce/utils/props";

defineProps({
  title: {
    type: String,
    required: true,
  },
  insurancePlan: {
    type: String,
    default: undefined,
  },
  nonClearable: booleanAttribute(),
});

const emit = defineEmits(["insurance-changed"]);

function insuranceChanged(value) {
  emit("insurance-changed", value);
}
</script>
